'use strict'
module.exports = {
  localStorage: {
    preset: 'hp-bn_'
  },
  tracking: {
    url: 'https://motrack.holidaypirates.group'
  },
  appName: 'Bananas',
  translation: {
    endpoint: 'https://motrack/translation/bananas'
  },
  enabledMarkets: {
    packages: ['de-DE', 'de-AT', 'de-CH'],
    hotels: [
      'de-DE',
      'de-AT',
      'de-CH',
      'en-GB',
      'en-US',
      'it-IT',
      'es-ES',
      'pl-PL',
      'fr-FR',
      'nl-NL'
    ],
    flights: [
      'de-DE',
      'de-AT',
      'de-CH',
      'en-GB',
      'en-US',
      'it-IT',
      'es-ES',
      'pl-PL',
      'fr-FR',
      'nl-NL'
    ],
    tours: [
      'de-DE',
      'de-AT',
      'de-CH',
      'en-GB',
      'en-US',
      'it-IT',
      'es-ES',
      'pl-PL',
      'fr-FR',
      'nl-NL'
    ]
  }
}
